<template>
  <div class="author-share-links__wrapper">
    <a-icon-list
      class="author-share-links"
      :icons="icons"
      :icon-width="16"
      :icon-height="16"
      open-in-new-tab
    />
  </div>
</template>

<script>
import AIconList from 'shared/AIconList'
import { ICON } from 'shared/AIcon'
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'AuthorIcons',
  components: { AIconList },
  props: {
    facebookUrl: propValidator([PROP_TYPES.STRING], false),
    twitterUrl: propValidator([PROP_TYPES.STRING], false),
    linkedInUrl: propValidator([PROP_TYPES.STRING], false),
    telegramUrl: propValidator([PROP_TYPES.STRING], false)
  },
  computed: {
    icons() {
      return [
        {
          url: this.twitterUrl,
          icon: ICON.X_PURPLE,
          ariaLabel: 'Twitter'
        },
        {
          url: this.facebookUrl,
          icon: ICON.FACEBOOK_PURPLE,
          ariaLabel: 'Facebook'
        },
        // {
        //   url: this.linkedInUrl,
        //   icon: ICON.LINKEDIN_PURPLE,
        //   ariaLabel: 'LinkedIn'
        // },
        {
          url: this.telegramUrl,
          icon: ICON.TELEGRAM_PURPLE,
          ariaLabel: 'Telegram'
        }
      ].filter(({ url }) => url)
    }
  }
}
</script>

<style lang="scss" scoped>
.author-share-links__wrapper {
  display: flex;
  margin: 20px 0;
}
</style>
